import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ModalShareQrAttendanceComponent } from "./components/modal-share-qr-attendance/modal-share-qr-attendance.component";
import { MyQrsMainPageComponent } from "./pages/my-qrs-main-page/my-qrs-main-page.component";

const routes: Routes = [
  {
    path: "",
    children: [
      { path: "", component: MyQrsMainPageComponent },
      {
        path: "view-attendece/:Id",
        component: ModalShareQrAttendanceComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyQrsCoursesCatalogRoutingModule {}
